import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d2c82e5")

_pushScopeId("data-v-1d2c82e5")
const _hoisted_1 = { class: "p-ml-4" }
const _hoisted_2 = { class: "p-mr-4" }
const _hoisted_3 = { class: "p-mr-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.notes.length === 0)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          class: "p-m-2",
          severity: "info",
          closable: false,
          style: _ctx.documentExecutionNotesDialogDescriptor.messageStyle
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.notes, (note) => {
          return (_openBlock(), _createBlock("div", {
            key: note.id
          }, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withId(() => [
                _createVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('common.owner') + ' ' + note.owner), 1)
              ]),
              end: _withId(() => [
                _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('common.creationDate') + ': ' + _ctx.getFormattedDate(note.creationDate)), 1),
                _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.lastChangeDate') + ': ' + _ctx.getFormattedDate(note.lastChangeDate)), 1),
                _createVNode(_component_Button, {
                  icon: "pi pi-pencil",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.onNoteEdit(note))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteNoteConfirm(note))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024),
            _createVNode("div", {
              innerHTML: note.content,
              class: "p-mt-0 p-ml-2 p-mr-2 p-mb-2 noteContent",
              disabled: ""
            }, null, 8, ["innerHTML"])
          ]))
        }), 128))
  ]))
})